import { makeStyles } from "@mui/styles";
import {
  fieldContainer,
  fieldLabel,
  fieldInput,
  twoFieldRow,
} from "../Form/fieldStyles";

const useStyles = makeStyles((theme) => ({
  container: twoFieldRow(theme),
  fieldGroup: { ...fieldContainer, flex: 1 },
  label1: fieldLabel,
  label2: fieldLabel,
  textField1: fieldInput,
  textField2: fieldInput,
}));

export default useStyles;
